import { safeReturnTo } from '../../pages/Delivery/Registries/returnTo';
import { registryHref } from '../../pages/Registries/registryHref';
const FULL_PAGE_KIND = {
    company: 'COMPANY',
    vehicle: 'VEHICLE',
    contact: 'CONTACT',
    govorg: 'GOVERNMENT_ORG',
    lcat_anchor: 'LCAT_ANCHOR',
    lcat_entry: 'LCAT_ENTRY'
};
/**
 * Deep link to the Registries record page for a shared identity. `origin` (path +
 * search) becomes returnTo only when the Registries validator accepts it, so a
 * bad origin yields a link with no Back rather than an unsafe one. With
 * `registries_records_v1` off, RegistryFlagRoute redirects to the drawer.
 */ export function registryRecordHref(kind, id, origin) {
    return registryHref({
        kind: FULL_PAGE_KIND[kind],
        id
    }, origin) ?? '/registries';
}
/** Existing Labor & Rates view (the view has no name filter to deep-link into). */ export function laborRatesHref(origin) {
    const returnTo = safeReturnTo(origin);
    return `/registries?tab=lcats${returnTo ? `&returnTo=${encodeURIComponent(returnTo)}` : ''}`;
}
/** Rate Book tab, pre-filtered. Every entry point consumes the same observations. */ export function rateBookHref(filter) {
    const q = new URLSearchParams({
        tab: 'rate-book'
    });
    if (filter.company) q.set('company', filter.company);
    if (filter.vehicle) q.set('vehicle', filter.vehicle);
    if (filter.lcat) q.set('lcat', filter.lcat);
    return `/registries?${q.toString()}`;
}
